import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import useSubjectModifiability from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Hooks/useSubjectModifiability';
import type * as React from 'react';

type Props = {
	readonly subject: SubjectAddress;
	readonly children: React.ReactNode;
};

/** Renders its children only once the dossier is loaded and accepts writes: it fails closed. */
const SpeakerAssignmentWritableGate: React.FC<Props> = ({ subject, children }) => {
	const { canModify } = useSubjectModifiability(subject);

	return <ConditionalLoader data={canModify}>{children}</ConditionalLoader>;
};

export default SpeakerAssignmentWritableGate;
